<form [formGroup]="form" fxLayout="row">
  <h4 fxFlex class="item-title">{{title}}</h4>

  <div class="quantity-input">
    <mat-form-field appearance="outline">
      <mat-label i18n>Model quantity</mat-label>
      <button mat-icon-button matPrefix (click)="minus()" [disabled]="types.length <= min">
        <mat-icon>remove</mat-icon>
      </button>
      <input matInput type="number" formControlName="quantity">
      <button mat-icon-button matSuffix (click)="plus()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
